import React = require("react");
import { DebugMessage } from "../../store/Utilities/type";
import JSONPretty = require('react-json-pretty');
import "./DebugWindow.css";


export interface IDebugWindowProps {
    onClose: () => void;
    messages: DebugMessage[];
    onClearMessages: () => void;
}

const DebugWindow = (props: IDebugWindowProps) => {
    const [expand, setExpand] = React.useState<boolean>(false);
    return (
        <div className={"debugWindowContainer " + (expand ? "expanded" : "")}
            style={{
                
            }}
        >
            <div className="debugWindowdisplayContainer">
                <div className="debugWindowHeader">
                    <button
                        className="btn btn-primary interactionButton"
                        onClick={() => window.location.reload()}
                    >
                        <i className="fa fa-refresh" aria-hidden="true" />
                    </button>
                    <h1>Debug</h1>
                    <button
                        className="btn btn-danger interactionButton"
                        onClick={() => props.onClose()}
                    >
                        <i className="fa fa-times" aria-hidden="true" />
                    </button>
                </div>
                <div className="debugWindowLogsContainer">
                    <ul>
                        {props.messages
                            .sort((a, b) => a.timestamp < b.timestamp ? 1 : -1)
                            .map((p, i) => (
                                <li key={`debug-message-${i}`} style={{ color: p.isError ? "red" : "#337ab7", fontSize: "16px" }}>
                                    <p>{p.timestamp} - {p.message}</p>
                                    {p.extraInfo &&
                                        <p style={{ paddingRight: "20px" }}>
                                            <JSONPretty data={p.extraInfo}/>
                                        </p>
                                    }
                                </li>
                            ))}
                    </ul>
                </div>
                <div className="debugWindowFooter">
                    <button
                        className="btn btn-primary interactionButton"
                        style={{ float: "right" }}
                        onClick={() => props.onClearMessages()}
                    >
                        <i className="fa fa-eraser" aria-hidden="true" />
                    </button>
                    <button
                        className="btn btn-primary interactionButton"
                        style={{ float: "right" }}
                        onClick={() => setExpand(!expand)}
                    >
                        <i className="fa fa-expand" aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
    );
}

export { DebugWindow }


// WEBPACK FOOTER //
// ./src/components/DebugWindow/DebugWindow.tsx